import {Image } from 'react-bootstrap';
import taiwan from "../data/taiwan.jpg";

function Header() {
    const text = {
        position: "absolute",
        top: "25vw",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "white",
        fontSize: "5vw"
    };
    return <div id="home">
        <Image src={taiwan} style={{backgroundSize: "cover"}} fluid/>
        <h1 style={text}>McGill Taiwanese Students Association</h1>
    </div>;
}

export default Header;